exports = module.exports = require("../../../../../../../../tools/web-builder/node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".filter-options-tab-5y3{width:486px}", "",{"version":3,"sources":["filter-options-tab.scss"],"names":[],"mappings":"AACA,wBACE,WAAA","file":"filter-options-tab.scss","sourcesContent":["\r\n.filter-options-tab-5y3 {\r\n  width: 486px;\r\n}"]}]);

